import { medtechApiClient } from './axios';
import { Tag } from '../types/tag';

export const tagsApi = {
  // Note the endpoint is scoped by query param, not by path: there is no
  // /{companyId}/tags. The company comes from `company_id`.
  async fetchTags(companyId: number): Promise<Tag[]> {
    return (await medtechApiClient.get<Tag[]>('/tags', { params: { company_id: companyId } })).data;
  },
};
